/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { FormConfig } from "@src/app/shared/form/FormConfig";
import { IsNarrowService } from '@src/app/shared/is-narrow.service';
import { TableComponent } from '@src/app/shared/table/table.component';
import { DialogBannerComponent } from '@src/app/shared/dialogs/dialog-banner-component';
export interface TableDialogOptions {
    config: FormConfig;
    items: AbstractObject[];
    id?: uuid;
    width?: number;
    height?: number;
    showSearch?: boolean;
    addOnly?: boolean;
}

@Component({
    selector: 'app-table-dialog',
    templateUrl: './table-dialog.component.html',
    styleUrls: ['./table-dialog.component.scss'],
    imports: [DialogBannerComponent, MatDialogContent, TableComponent]
})
export class TableDialogComponent implements OnInit, AfterViewInit {
    protected isNarrowSvc = inject(IsNarrowService);
    dialogRef = inject<MatDialogRef<TableDialogComponent>>(MatDialogRef);
    data = inject<TableDialogOptions>(MAT_DIALOG_DATA);


    @ViewChild(TableComponent) table: TableComponent;

    config: FormConfig;
    width = 500;

    private initialised = new Subject<null>();

    constructor() {
        const data = this.data;


        this.config = data.config;

        if (!data.config.mode) {
            this.config.mode = 'list';
        }
        //this.dialogRef.disableClose = true; Close Button not showing, emergency fix until it does!
        //TODO - Override Params?....
    }

    ngOnInit(): void {
        this.width = this.isNarrowSvc.screenWidth * .75;
    }

    ngAfterViewInit() {
        /* Calling direct caused issue with ExpressionChangedAfterItHasBeenChecked */
        this.initialised.subscribe(() => this.loadTableData());
        setTimeout(() => {
            this.initialised.next(null);
            this.initialised.complete();
        }, 10);
    }

    loadTableData() {
        this.table.loadData(this.data.items);
    }

}
